import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 12,
	viewBox: "0 0 18 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 1H17M4.2 6H13.8M6.33333 11H11.6667",
		stroke: "#66798D",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgFilter;
